<template>
  <div class="wrapper">
    <template>
      <div class="wrapper__cards">
        <AdvertisingBudget
          :balance="commissionBalance.balance"
          :leftover="commissionBalance.leftover"
          :on_hold="commissionBalance.on_hold"
        />
        <div class="wrapper__cards__buttonBlock">
          <a-button
            type="primary"
            @click="topUpModalIsVisible = true"
          >
            {{ $t("tariffs.cpa_statistics.top_up_balance") }}
          </a-button>
          <a-button @click="requestCommission">
            <a-icon type="question" />
            {{ $t("tariffs.cpa_statistics.askQuestion") }}
          </a-button>
        </div>
        <!-- <AdvertisingStatus
          :loading="fetchingCpa"
          :percentOfOrder="percent"
          :statusText="cpaStatusText"
          :statusColor="cpaStatusColor"
          :cpaKind="cpaKind"
        /> -->
      </div>

      <AdvertisingTable />
    </template>

    <BillingTopUp
      :visible="topUpModalIsVisible"
      @close="topUpModalIsVisible = false"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

import BillingTopUp from "@/components/Common/BillingTopUp/BillingTopUp.vue"
import priceMixin from "@/mixins/price"
import { HANDLE_SUPPORT_DRAWER } from "@/store/modules/notifications/mutationTypes"

import AdvertisingBudget from "./_components/AdvertisingBudget.vue"
import AdvertisingStatus from "./_components/AdvertisingStatus.vue"
import AdvertisingTable from "./_components/AdvertisingTable.vue"

export default {
  name: "CpaStatistics",

  mixins: [priceMixin],

  components: {
    AdvertisingBudget,
    AdvertisingStatus,
    AdvertisingTable,
    BillingTopUp
  },

  metaInfo() {
    return {
      titleTemplate: `%s - ${this.$t("navbar.adversting.cpa_statistics")}`
    }
  },

  data() {
    return {
      status: null,
      percent: 0,
      cpaKind: "DISABLED",
      topUpModalIsVisible: false
    }
  },

  computed: {
    ...mapState("user", {
      commissionBalance: (state) => state.commissionBalance
    }),

    cpaStatusText() {
      if (this.status === "ACTIVE") {
        return this.$t("adversting.active")
      } else if (this.status === "PAUSED_NO_MONEY") {
        return this.$t("adversting.suspended")
      } else if (this.status === "TURNED_OFF") {
        return this.$t("adversting.disabled")
      }

      return ""
    },
    cpaStatusColor() {
      switch (this.status) {
        case "ACTIVE":
          return "#00C84a"
        case "PAUSED_NO_MONEY":
          return "#ff0000"
        default:
          return "#262626"
      }
    }
  },

  methods: {
    ...mapMutations("notifications", [HANDLE_SUPPORT_DRAWER]),
    requestPartnersReward() {
      this[HANDLE_SUPPORT_DRAWER]({
        subject: this.$t("adversting.request_partners_ads"),
        text: this.$t("adversting.request_body_cpa", {
          price: this.getPriceWithCurrency(1000, true)
        }),
        open: true
      })
    },

    requestCommission() {
      this[HANDLE_SUPPORT_DRAWER]({
        subject: this.$t("tariffs.cpa_statistics.request_comission_cpa"),
        open: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100%;
  position: relative;

  &__alert {
    margin-bottom: 30px;
  }

  &__loader {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__cards {
    display: grid;
    grid-template-columns: 555px auto;
    margin-bottom: 32px;
    &__buttonBlock {
      margin: auto;
      display: flex;
      flex-flow: row wrap;
      gap: 8px;
      margin-right: 0;
    }
  }
}
</style>
